export default "__VITE_ASSET__BL53xrIl__"